export enum CareCoordinationSubWidget {
  Sdoh = 'SDoH',
  Wcc = 'wound-management',
  CaseManagement = 'case-management',
  Referral = 'referral'
}

export enum CareCoordinationSubWidgetTab {
  Sdoh,
  Wcc,
  CaseManagement,
  Referral
}
